import type { BankApp } from './bankApps';
export type { BankPlatform as KztBankPlatform, BankVerification as KztBankVerification } from './bankApps';

export type KztBankId = 'halyk' | 'kaspi' | 'freedom' | 'forte' | 'bcc' | 'bereke';

export interface KztBankApp extends BankApp {
    readonly id: KztBankId;
}

// An official link is not proof that an installed app opens. Keep verification null
// until the device checklist passes for that OS. These records document testing;
// buttons are enabled independently of verification.
export const KZT_BANK_APPS: readonly KztBankApp[] = [
    {
        id: 'halyk',
        name: 'Halyk',
        logo: '/assets/banks/kzt/halyk.svg',
        background: '#007B62',
        color: '#FFFFFF',
        sourceUrl: 'https://halykbank.kz/homebank',
        evidence: 'official-link',
        android: { url: 'https://halyk.go.link/dzXxN', verification: null },
        ios: { url: 'https://halyk.go.link/dzXxN', verification: null },
    },
    {
        id: 'kaspi',
        name: 'Kaspi.kz',
        logo: '/assets/banks/kzt/kaspi.svg',
        logoBackground: '#FFFFFF',
        background: '#E91621',
        color: '#FFFFFF',
        sourceUrl: 'https://main.kaspi.kz/.well-known/apple-app-site-association',
        evidence: 'domain-association-candidate',
        android: { url: 'https://main.kaspi.kz/', verification: null },
        ios: { url: 'https://main.kaspi.kz/', verification: null },
    },
    {
        id: 'freedom',
        name: 'Freedom Bank',
        logo: '/assets/banks/kzt/freedom.svg',
        background: '#327800',
        color: '#FFFFFF',
        sourceUrl: 'https://bankffin.kz/ru',
        evidence: 'official-link',
        android: { url: 'https://freedombank.onelink.me/WNLd/footer071124', verification: null },
        ios: { url: 'https://freedombank.onelink.me/WNLd/footer071124', verification: null },
    },
    {
        id: 'forte',
        name: 'Forte',
        logo: '/assets/banks/kzt/forte.svg',
        background: '#951247',
        color: '#FFFFFF',
        sourceUrl: 'https://forte.kz/ru/inform/vnimaniyu-klientov-2',
        evidence: 'official-link',
        android: { url: 'https://forteapp.onelink.me/clGL/k4bofj92', verification: null },
        ios: { url: 'https://forteapp.onelink.me/clGL/k4bofj92', verification: null },
    },
    {
        id: 'bcc',
        name: 'БЦК',
        logo: '/assets/banks/kzt/bcc.svg',
        background: 'linear-gradient(105deg, #D9A360, #F4D7AF)',
        color: '#3A2817',
        sourceUrl: 'https://www.bcc.kz/personal/bcc-mobile-app/',
        evidence: 'official-link',
        android: { url: 'https://bcc-kz.onelink.me/DHqP/4a2103hk', verification: null },
        ios: { url: 'https://bcc-kz.onelink.me/DHqP/4a2103hk', verification: null },
    },
    {
        id: 'bereke',
        name: 'Bereke Bank',
        logo: '/assets/banks/kzt/bereke.svg',
        logoBackground: '#FFFFFF',
        background: 'linear-gradient(105deg, #0348E8, #007E32)',
        color: '#FFFFFF',
        sourceUrl: 'https://berekebank.kz/ru',
        evidence: 'official-link',
        android: { url: 'https://berekebank.onelink.me/lyyx/storelink', verification: null },
        ios: { url: 'https://berekebank.onelink.me/lyyx/storelink', verification: null },
    },
];
